import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzResultModule } from 'ng-zorro-antd/result';
import { UserClerkCallBackendService } from '../../core/user/user-clerk-call-backend.service';
import { UserClerkService } from '../../core/user/user-clerk.service';

@Component({
  selector: 'app-login-chrome-extension',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonComponent, NzIconModule, NzResultModule],
  templateUrl: './login-chrome-extension.component.html',
  styleUrl: './login-chrome-extension.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginChromeExtensionComponent {
  constructor(
    private userClerkService: UserClerkService,
    private httpClient: HttpClient,
    private userClerkCallBackendService: UserClerkCallBackendService
  ) {}

  async ngOnInit() {
    const accessToken = await this.userClerkService.getToken();
    const userInfoStr = JSON.stringify({ accessToken: accessToken, user: this.userClerkService.getUser() });

    document.dispatchEvent(
      new CustomEvent('sendUserInfoEvent', {
        detail: { message: userInfoStr },
      })
    );
  }

  onCloseTabClick() {
    window.close();
  }
}
